/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Goal_LongInputs */

const en_us2_intake_why_goal_long = /** @type {(inputs: Intake_Why_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength, hypertrophy and recomposition each use different sets, reps and rest. This is the biggest switch in the plan.`)
};

const pt_br2_intake_why_goal_long = /** @type {(inputs: Intake_Why_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força, hipertrofia e recomposição usam séries, repetições e descansos diferentes. É a maior chave do plano.`)
};

const es_419_intake_why_goal_long = /** @type {(inputs: Intake_Why_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuerza, hipertrofia y recomposición usan series, repeticiones y descansos distintos. Es la decisión más grande del plan.`)
};

const pt_pt2_intake_why_goal_long = /** @type {(inputs: Intake_Why_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força, hipertrofia e recomposição usam séries, repetições e descansos diferentes. É o maior interruptor do plano.`)
};

const fr_fr2_intake_why_goal_long = /** @type {(inputs: Intake_Why_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force, hypertrophie et recomposition utilisent des séries, des répétitions et des repos différents. C'est le plus grand levier du programme.`)
};

const de_de2_intake_why_goal_long = /** @type {(inputs: Intake_Why_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraft, Hypertrophie und Rekomposition nutzen jeweils andere Sätze, Wiederholungen und Pausen. Das ist der wichtigste Schalter im Plan.`)
};

const it_it2_intake_why_goal_long = /** @type {(inputs: Intake_Why_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza, ipertrofia e ricomposizione usano serie, ripetizioni e recuperi diversi. È la scelta più importante della scheda.`)
};

/**
* | output |
* | --- |
* | "Strength, hypertrophy and recomposition each use different sets, reps and rest. This is the biggest switch in the plan." |
*
* @param {Intake_Why_Goal_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_goal_long = /** @type {((inputs?: Intake_Why_Goal_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Goal_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_goal_long(inputs)
	if (locale === "es-419") return es_419_intake_why_goal_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_goal_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_goal_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_goal_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_goal_long(inputs)
	return en_us2_intake_why_goal_long(inputs)
});
export { intake_why_goal_long as "intake.why.goal.long" }